import EwaybillType from "@/enum/EwaybillType";
import LogisticsCompany from "@/enum/LogisticsCompany";
import { get, post } from "@/services/http/platformServer";
import { ExtendAxiosRequestConfig } from "@/services/http/types";
import { PagedResult } from "./types";

export enum InstantShipPostPayInterval {
    TEN_MINUTES = "TEN_MINUTES",
    TWENTY_MINUTES = "TWENTY_MINUTES",
    THIRTY_MINUTES = "THIRTY_MINUTES",
    FORTY_MINUTES = "FORTY_MINUTES",
    FIFTY_MINUTES = "FIFTY_MINUTES",
    SIXTY_MINUTES = "SIXTY_MINUTES",
}

export enum InstantShipTaskStatus {
    RUNNING = "RUNNING",
    CLOSED = "CLOSED",
}

export enum InstantShipOrderRecordType {
    SUCCESS = "SUCCESS",
    GENERATE_FAIL = "GENERATE_FAIL",
    SHIP_FAIL = "SHIP_FAIL",
    SKIP = "SKIP",
}

export interface InstantShipWaybillTemplate {
    id: number;
    name: string;
    logisticsCompany: LogisticsCompany;
    serviceOptions?: string;
    printTemplateUrl?: string;
    printTemplateId?: string;
    templateVersion?: number;
}

export interface InstantShipEwaybillAccount {
    id: number;
    shopId: number;
    type: EwaybillType;
    name?: string;
    platformUsername?: string;
    ewaybillShippingAddressIds?: number[];
}

export interface InstantShipEwaybillShippingAddress {
    id: number;
    province?: string;
    city?: string;
    district?: string;
    town?: string;
    street?: string;
}

export interface InstantShipShippingAddress {
    id: number;
    shipperName?: string;
    province?: string;
    city?: string;
    district?: string;
    street?: string;
    telephone?: string;
    mobile?: string;
}

export interface InstantShipPrintConfig {
    waybillTemplate: InstantShipWaybillTemplate;
    ewaybillAccount: InstantShipEwaybillAccount;
    ewaybillShippingAddress: InstantShipEwaybillShippingAddress;
    shippingAddress: InstantShipShippingAddress;
    useChildWaybillNoMode: boolean;
}

export interface OpenInstantShipTaskParams {
    shopId: number;
    postPayInterval: InstantShipPostPayInterval;
    printConfig: InstantShipPrintConfig;
    disclaimerConfirmed: boolean;
}

export interface InstantShipTask {
    id: number;
    shopId: number;
    status: InstantShipTaskStatus;
    startTime: string;
    postPayInterval: InstantShipPostPayInterval;
    printConfig: InstantShipPrintConfig;
    successCount: number;
    failCount: number;
}

export interface InstantShipOrderRecord {
    dateCreated?: string;
    lastUpdated?: string;
    id: number;
    shopId: number;
    taskId: number;
    orderId: number;
    originalId: string;
    splitChildOrderOriginalId?: string;
    consignee?: string;
    paymentTime?: string;
    generateTime?: string;
    shippingTime?: string;
    logisticsCompany?: LogisticsCompany;
    waybillNos?: string;
    message?: string;
    type: InstantShipOrderRecordType;
}

export interface GetInstantShipOrderRecordsParams {
    shopId: number;
    taskId: number;
    type?: InstantShipOrderRecordType;
    pageNo: number;
    pageSize: number;
}

export function openInstantShipTask(params: OpenInstantShipTaskParams) {
    return post<InstantShipTask>(params.shopId, "/instant_ship/task/open", params);
}

export function closeInstantShipTask(shopId: number) {
    return post<InstantShipTask>(shopId, "/instant_ship/task/close", { shopId });
}

export function getCurrentInstantShipTask(shopId: number, config?: ExtendAxiosRequestConfig) {
    return post<InstantShipTask>(shopId, "/instant_ship/task/current", { shopId }, config);
}

export function getInstantShipOrderRecords(
    params: GetInstantShipOrderRecordsParams,
    config?: ExtendAxiosRequestConfig,
) {
    return post<PagedResult<InstantShipOrderRecord>>(params.shopId, "/instant_ship/task/records", params, config);
}
